import React, { useState, useEffect } from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { FormHelperText, InputLabel, NativeSelect } from "@material-ui/core";
import { KeyboardTimePicker } from "@material-ui/pickers";
import DataClient from "../../../../../Service/general_data_service";
import CustomSelectMulti from "../../../../../Components/CustomSelectMulti";
import DataService from "../../../../../Service";
import {
  DateFormat,
  DateFormatter,
} from "../../../../../Common/Utils/common_utils";
import { FormControl } from "@material-ui/core";
import { TextareaAutosize } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import {
  Box,
  Avatar,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Typography,
  AppBar,
  Toolbar,
  MenuItem,
  Select,
} from "@material-ui/core";
import DateRangeIcon from "@material-ui/icons/DateRange";
import ScheduleIcon from "@material-ui/icons/Schedule";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import HistoryIcon from "@material-ui/icons/History";
import CustomInput from "../../../../../Components/CustomInput";
import DateComponent from "../../../../../Components/FormGenerator/datepicker_component";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "75%",
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  pos: {
    marginBottom: 12,
  },
  small: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    margin: "0 auto",
  },
  approved: {
    // color: "#38B122",
    color: "#fff",
    fontWeight: "bold",
    background: "#a3a110",
    // border: "1px solid #38B122",
    padding: 5,
  },
  notApproved: {
    color: "#ff0000",
    border: "1px solid #ff0000",
    padding: 5,
  },
  overviewContainer: {
    position: "sticky",
    top: 64,
    paddingTop: 40,
    background: "#fff",
    zIndex: 1,
  },
  appBar: {
    backgroundColor: "#fff",
    color: "#232323",
    boxShadow: "0px 3px 6px #232323",
    marginBottom: "2rem",
  },
  custom_timepicker: {
    "& .MuiInputBase-root": {
      border: "1px solid rgba(0, 0, 0, 0.23)",
      borderRadius: 5,
    },
    "& .MuiInputBase-input": {
      padding: "9px 12px !important",
    },
    "& .MuiInput-underline.Mui-error:after, & .MuiInput-underline:before": {
      content: "' '",
      border: "0px !important",
      transition: "none",
    },
    "& .MuiIconButton-root": {
      padding: "0px 5px 0px 0px",
    },
  },
  textAreaEmpty: {
    color: "rgba(0, 0, 0, 0.87)",
    width: "97%",
    border: "1px solid rgb(196 196 196)",
    padding: "10px",
    borderRadius: "4px",
    font: "inherit",
    display: "block",
    outline: "none",

    "&:focus": {
      border: "2px solid #3B86FF",
    },
  },
  nativeSelect: {
    border: "1px solid grey",
    borderRadius: "5%",
    "& select": {
      padding: "10px",
      "&:focus": {
        backgroundColor: "transparent",
      },
    },
    "&::before": {
      borderBottom: "0px !important",
    },
    "&::after": {
      outline: "2px solid  #077F83",
      border: "none !important",
      top: "0",
      borderRadius: "3px",
    },
    "&:hover": {
      border: "0.5px solid black",
    },
  },
  nativeOption: {
    padding: "5px",
  },
}));

function ChemistrySession(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [submitClickFlag, setSubmitClickFlag] = useState(false);
  const [stakeholderListsArr, setsStakeholderListsArr] = useState([]);
  const [stakeholder_Attribute, setStakeholder_Attribute] = useState([]);
  const [maxWidth, setMaxWidth] = React.useState("md");
  //
  const [pageData, setPageData] = useState([]);
  const [action, setAction] = useState("");
  const dispatch = useDispatch();
  const [sessionDetail, setSessionDetail] = useState({});
  const [textArea, setTextArea] = useState({
    agenda: "",
    session_notes: "",
    note_to_acuity_admin: "",
    // feedback: ""
  });

  ///
  const [hourArray, setHourArray] = useState();
  const [minuteArray, setMinuteArray] = useState();
  // const [sessionDetailID, setSessionDetailID] = useState();
  ///
  const [coachID, setCoachID] = useState();
  const [shortlistCoachID, setShortlistCoachID] = useState();
  const [expanded, setExpanded] = useState(false);

  //
  const [sessionDetailID, setSessionDetailID] = useState();
  const [userData, setUserData] = useState({
    session_date: "",
    // start_time: "",
    // end_time: "",
    location: "",
  });

  ///
  const [clockData, setClockData] = useState({
    start_time_hours: "",
    start_time_minutes: "",
    end_time_hours: "",
    end_time_minutes: "",
  });
  const [sessionInputErrors, setSessionInputErrors] = useState({
    session_date: false,
    location: false,
    stakeHoldersInvolved: false,
    start_time_hours: false,
    start_time_minutes: false,
    end_time_hours: false,
    end_time_minutes: false,
  });
  //
  const showAcuityNotes = useSelector((state) => state.commonReducer)
    ?.accessPermission.assignmentDetail.sessions?.showAcuityNotes;
  //
  const handleClickOpen = () => {
    setOpen(true);
    createHourOption();
    createMinuteOption();
  };

  const handleClose = () => {
    setOpen(false);
    setUserData({
      ...userData,
      session_date: "",
      start_time: "",
      end_time: "",
      location: "",
    });
    setClockData({
      start_time_hours: "",
      start_time_minutes: "",
      end_time_hours: "",
      end_time_minutes: "",
    });
    setTextArea({
      agenda: "",
      session_notes: "",
      note_to_acuity_admin: "",
      // feedback: ""
    });
    setSubmitClickFlag(false);
    setShortlistCoachID("");
    stakeholder_Attribute.length = 0;
    setSessionInputErrors({
      session_date: false,
      location: false,
      stakeHoldersInvolved: false,
      start_time_hours: false,
      start_time_minutes: false,
      end_time_hours: false,
      end_time_minutes: false,
    });
  };

  useEffect(() => {
    // getData();
    getCoachList();
    getStakeHolder();
  }, []);

  // useEffect(() => {

  // }, [pageData]);

  const getCoachList = () => {
    DataService.getDirectData("shortlisting_coaches/fetch_chemistry_coaches", {
      assignment_id: props.location.state.currentAssignment.id,
    }).then((res) => {
      pageData.length = 0;
      setPageData(pageData?.concat(res.chemistry_coaches));
    });
  };
  //
  const saveSession = (e) => {
    e.preventDefault();
    let blockRequest = false;

    if (userData.session_date === "" || userData.session_date === null) {
      setSessionInputErrors((prev) => {
        return { ...prev, session_date: true };
      });
      blockRequest = true;
    }
    if (userData.location === "") {
      setSessionInputErrors((prev) => {
        return { ...prev, location: true };
      });
      blockRequest = true;
    }
    if (stakeholder_Attribute.length === 0) {
      setSessionInputErrors((prev) => {
        return { ...prev, stakeHoldersInvolved: true };
      });
      blockRequest = true;
    }

    const timeError = {
      start_time_hours: false,
      start_time_minutes: false,
      end_time_hours: false,
      end_time_minutes: false,
    };
    if (clockData.start_time_hours === "") {
      timeError.start_time_hours = true;
    }
    if (clockData.start_time_minutes === "") {
      timeError.start_time_minutes = true;
    }
    if (clockData.end_time_hours === "") {
      timeError.end_time_hours = true;
    }
    if (clockData.end_time_minutes === "") {
      timeError.end_time_minutes = true;
    }
    if (
      timeError.start_time_hours ||
      timeError.start_time_minutes ||
      timeError.end_time_hours ||
      timeError.end_time_minutes
    ) {
      setSessionInputErrors((prev) => {
        return { ...prev, ...timeError };
      });
      blockRequest = true;
    }
    if (blockRequest) {
      setSubmitClickFlag(true);
    } else {
      var stakeholderLocalArr = stakeholder_Attribute.map(
        (option) => option.id
      );
      if (action == "save") {
        const pdata = {
          assignment_id: props.assignmentId,
          pgm_flow_id: props.currentObj.pgm_flow_id,
          shortlisting_coach_id: shortlistCoachID,
          stakeholder_user_id: stakeholderLocalArr,
          ...userData,
          session_date: DateFormat(userData.session_date),
          start_time: `${clockData.start_time_hours} : ${clockData.start_time_minutes}`,
          end_time: `${clockData.end_time_hours} : ${clockData.end_time_minutes}`,
          // start_time: moment(userData.start_time).format("YYYY-MM-DD hh:mm A"),
          // end_time: moment(userData.end_time).format("YYYY-MM-DD hh:mm A"),
          ...textArea,
          agenda: textArea.agenda,
          session_notes: textArea.session_notes,
          note_to_acuity_admin: textArea.note_to_acuity_admin,
          // feedback: textArea.feedback
        };
        DataClient.create(pdata, "session_details")
          .then((res) => {
            dispatch(
              showSnackbar("Success", ["Information saved successfully"])
            );
            // getData(shortlistCoachID);
            handleClose();
            getCoachList();
            getStakeHolder();
            // setPageData({ ...pageData, ...res.assignment })
          })
          .catch((res) => {});
      } else {
        // debugger
        const pdata = {
          assignment_id: props.assignmentId,
          pgm_flow_id: props.currentObj.pgm_flow_id,
          session_detail_id: sessionDetailID,
          shortlisting_coach_id: shortlistCoachID,
          stakeholder_user_id: stakeholderLocalArr,
          ...userData,
          session_date: DateFormat(userData.session_date),
          // start_time: moment(userData.start_time).format("YYYY-MM-DD hh:mm A"),
          // end_time: moment(userData.end_time).format("YYYY-MM-DD hh:mm A"),
          start_time: `${clockData.start_time_hours} : ${clockData.start_time_minutes}`,
          end_time: `${clockData.end_time_hours} : ${clockData.end_time_minutes}`,
          ...textArea,
          agenda: textArea.agenda,
          session_notes: textArea.session_notes,
          note_to_acuity_admin: textArea.note_to_acuity_admin,
          // feedback: textArea.feedback
        };
        DataClient.update(pdata, "session_details/update_session_detail")
          .then((res) => {
            dispatch(
              showSnackbar("Success", ["Information updated successfully"])
            );
            // getData(shortlistCoachID);
            handleClose();
            getCoachList();
            // setPageData({ ...pageData, ...res.assignment })
          })
          .catch((res) => {});
      }
    }
  };
  const updateSession = (elem, flag) => {
    console.log(elem, "cancel session elemen");
    var pdata = {
      session_detail_id: elem.session_detail_id,
      pgm_flow_id: props.currentObj.pgm_flow_id,
      assignment_id: props.assignmentId,
    };
    props.id != "" && (pdata["sequence_id"] = props.id);
    let url = "";
    if (flag === "complete") {
      url = "session_details/complete_session";
    }
    if (flag === "cancel") {
      url = "session_details/cancel_session";
    }
    DataClient.create(pdata, url)
      .then((res) => {
        // setWarningArr(res.warning);
        // setWarningArr(prev=>{return [...prev,...res.warning]});
        dispatch(
          showSnackbar("Success", ["Session status updated successfully"])
        );
        getCoachList();
        getStakeHolder();
        getData();
        props.getAssignmentModule();
      })
      .catch((res) => {});
  };
  const beforeEditSession = () => {
    setUserData({
      ...userData,
      session_date: sessionDetail.session_date,
      // start_time: moment(
      //   `${moment().format("YYYY-MM-DD")} ${sessionDetail.start_time}`
      // ),
      // end_time: moment(
      //   `${moment().format("YYYY-MM-DD")} ${sessionDetail.end_time}`
      // ),
      location: sessionDetail.location,
    });
    setClockData({
      ...clockData,
      start_time_hours: sessionDetail?.start_time.split(":")[0],
      start_time_minutes: sessionDetail?.start_time.split(":")[1],
      end_time_hours: sessionDetail?.end_time.split(":")[0],
      end_time_minutes: sessionDetail?.end_time.split(":")[1],
    });
    setTextArea({
      ...textArea,
      agenda: sessionDetail.agenda,
      session_notes: sessionDetail.session_notes,
      note_to_acuity_admin: sessionDetail.note_to_acuity_admin,
    });

    sessionDetail.stakeholders?.map((option) => {
      option["value"] = option.name;
      option["id"] = option.user_id;
      option["name"] = option.value;
      option["label"] = option.name;
    });
    stakeholder_Attribute.length = 0;
    setStakeholder_Attribute(
      stakeholder_Attribute?.concat(sessionDetail.stakeholders)
    );
    setAction("edit");
    handleClickOpen();
  };

  //
  const createHourOption = () => {
    let newArray = [];
    for (let i = 0; i <= 24; i++) {
      i.toString().length > 1 ? newArray.push(i) : newArray.push("0" + i);
    }
    setHourArray(newArray);
  };
  const createMinuteOption = () => {
    let newArray = [];
    for (let i = 0; i <= 60; i++) {
      if (i % 5 === 0) {
        i.toString().length > 1 ? newArray.push(i) : newArray.push("0" + i);
      }
    }
    setMinuteArray(newArray);
  };
  const selectChange = (value, key) => {
    setClockData((prev) => {
      return { ...prev, [key]: value };
    });
    if (value !== "") {
      setSessionInputErrors((prev) => {
        return { ...prev, [key]: false };
      });
    }
  };

  const getData = (params) => {
    var pdata =
      "assignment_id=" +
      props.assignmentId +
      "&shortlisting_coach_id=" +
      params;

    DataClient.getData("shortlisting_coaches/fetch_chemistry_session?" + pdata)
      .then((res) => {
        let sessionDetailID = res.shortlisting_coaches[0].session_detail
          ? res.shortlisting_coaches[0].session_detail.id
          : "";
        setSessionDetailID(sessionDetailID);
        setSessionDetail(res.shortlisting_coaches[0].session_detail);
      })
      .catch((res) => {});
  };
  const getStakeHolder = () => {
    DataClient.getData(
      "session_details/fetch_stakeholders_involved_in?assignment_id=" +
        props.assignmentId +
        "&chemistry_coaches=true"
    )
      .then((res) => {
        res.stakeholder_user.map((option) => (option["value"] = option.name));
        stakeholderListsArr.length = 0;
        setsStakeholderListsArr(
          stakeholderListsArr.concat(res.stakeholder_user)
        );
      })
      .catch((res) => {});
  };
  const setInputState = (inputStateValue, inputId) => {
    setUserData({ ...userData, [inputId]: inputStateValue });
    if (["session_date", "location"].includes(inputId)) {
      if (inputStateValue) {
        setSessionInputErrors((prev) => {
          return { ...prev, [inputId]: false };
        });
      }
    }
  };

  const handleChangeTextArea = (event) => {
    const { name, value } = event.target;
    setTextArea((prev) => ({ ...prev, [name]: value }));
  };
  const onScheduleChangeItem = (inputStateValue, inputId, index) => {
    setUserData({ ...userData, [inputId]: inputStateValue });
  };

  const onChangeMultiItem = (obj, inputId, routeFrom) => {
    if (inputId == "stakeholder_Attribute") {
      if (obj.length > 0) {
        setSessionInputErrors((prev) => {
          return { ...prev, stakeHoldersInvolved: false };
        });
      }
      stakeholder_Attribute.length = 0;
      setStakeholder_Attribute(stakeholder_Attribute.concat(obj));
    }
  };

  return (
    <>
      <Grid container direction="row" justify="center" alignItems="center">
        <Grid
          item
          xs={11}
          style={{ textAlign: "center" }}
          direction="row"
          justify="center"
          alignItems="center"
          className={classes.overviewContainer}
        >
          <AppBar position="static" className={classes.appBar} elevation={0}>
            <Toolbar>
              <Grid
                container
                direction="row"
                justify="left"
                alignItems="left"
                xs={12}
              >
                <Grid item xs={6}>
                  <Typography variant="h1" style={{ color: "rgb(74, 74, 74)" }}>
                    <Box textAlign="left" fontWeight="fontWeightBold">
                      Chemistry session
                    </Box>
                  </Typography>
                </Grid>
                <Grid item xs={6} style={{ alignSelf: "center" }}>
                  <Box textAlign="right">
                    <Button
                      disableElevation
                      variant="contained"
                      color="secondary"
                      onClick={() => props.setPageUrl("Coach shortlist")}
                      style={{ textTransform: "none" }}
                    >
                      Go to coach shortlist
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Toolbar>
          </AppBar>
        </Grid>
        <Grid item xs="11">
          <Card className={classes.root} variant="outlined">
            <CardContent style={{ paddingBottom: "0px" }}>
              <Typography variant="subtitle1">
                <Box mb={3} fontWeight="fontWeightBold">
                  Shortlisted coaches for chemistry
                </Box>
              </Typography>
              {pageData.length > 0 &&
                pageData.map((data) => {
                  return data.session_scheduled === "N/A" ? (
                    <Grid container direction="row" alignItems="center">
                      <Grid item xs="12">
                        <Box my={2}>
                          <Grid
                            container
                            direction="row"
                            alignItems="center"
                            spacing={2}
                          >
                            <Grid item xs="1">
                              <Box>
                                <Avatar
                                  alt="Remy Sharp"
                                  src={""}
                                  className={classes.small}
                                />
                              </Box>
                            </Grid>
                            <Grid item xs="6">
                              <Typography variant="h2">
                                <Box fontWeight="fontWeightBold">
                                  {data.coach_name}
                                </Box>
                              </Typography>
                            </Grid>
                            <Grid item xs="5">
                              <Box textAlign="right">
                                <Button
                                  disableElevation
                                  variant="contained"
                                  color="secondary"
                                  className={classes.btnComplete}
                                  onClick={() => {
                                    setAction("save");
                                    handleClickOpen();
                                    setShortlistCoachID(
                                      data.shortlisting_coach_id
                                    );
                                  }}
                                >
                                  <HistoryIcon /> &nbsp;{" "}
                                  <span style={{ textTransform: "none" }}>
                                    Schedule chemistry session
                                  </span>
                                </Button>
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      </Grid>
                    </Grid>
                  ) : (
                    <Accordion
                      style={{ position: "unset", boxShadow: "none" }}
                      expanded={expanded === data.shortlisting_coach_id}
                      onChange={(event, isExpanded) => {
                        setExpanded(
                          isExpanded ? data.shortlisting_coach_id : false
                        );
                        getData(data.shortlisting_coach_id);
                      }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        style={{ paddingLeft: "0" }}
                        // onClick={() => { }}
                      >
                        <Grid container direction="row" alignItems="start">
                          <Grid item xs="1">
                            <Box
                              style={{ paddingRight: "8px", height: "100%" }}
                            >
                              <Avatar
                                alt="Remy Sharp"
                                src={""}
                                className={classes.small}
                              />
                            </Box>
                          </Grid>
                          <Grid
                            item
                            xs="5"
                            style={{ paddingLeft: "6px", height: "100%" }}
                          >
                            <Typography variant="h2">
                              <Box fontWeight="fontWeightBold">
                                {data.coach_name}
                              </Box>
                            </Typography>
                          </Grid>
                          <Grid item xs="6">
                            {expanded === data.shortlisting_coach_id ? (
                              <Grid container style={{ rowGap: "16px" }}>
                                {!(
                                  sessionDetail?.status === "cancelled" ||
                                  sessionDetail?.status === "completed"
                                ) ? (
                                  <>
                                    {" "}
                                    <Grid
                                      item
                                      xs={5}
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <Button
                                        disableElevation
                                        variant="contained"
                                        style={{
                                          backgroundColor: "#C71C1C",
                                          color: "#fff",
                                          textTransform: "none",
                                          fontSize: "12px",
                                        }}
                                        onClick={() => {
                                          updateSession(data, "cancel");
                                        }}
                                      >
                                        Cancel session
                                      </Button>
                                    </Grid>
                                    <Grid item xs={7}>
                                      <Button
                                        disableElevation
                                        variant="contained"
                                        style={{
                                          backgroundColor: "transparent",
                                          borderWidth: 1,
                                          borderStyle: "solid",
                                          borderColor: "#03B11E",
                                          color: "#03B11E",
                                          textTransform: "none",
                                          marginLeft: 10,
                                          fontSize: "12px",
                                        }}
                                        onClick={() => {
                                          updateSession(data, "complete");
                                        }}
                                      >
                                        Mark session as complete
                                      </Button>
                                    </Grid>
                                  </>
                                ) : sessionDetail?.status === "cancelled" ? (
                                  <Grid
                                    item
                                    xs={12}
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    <Box textAlign="right">
                                      <Button
                                        disableElevation
                                        variant="contained"
                                        style={{
                                          backgroundColor: "#C71C1C",
                                          color: "#fff",
                                          textTransform: "capitalize",
                                          marginRight: "10px",
                                          fontSize: "12px",
                                        }}
                                      >
                                        <CheckCircleIcon />
                                        &nbsp;Cancelled
                                      </Button>
                                    </Box>
                                  </Grid>
                                ) : (
                                  <Grid
                                    item
                                    xs={12}
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    <Box textAlign="right">
                                      <Button
                                        disableElevation
                                        variant="contained"
                                        style={{
                                          backgroundColor: "#21BA45",
                                          color: "#fff",
                                          textTransform: "none",
                                          fontSize: "12px",
                                        }}
                                      >
                                        <CheckCircleIcon />
                                        &nbsp;Session completed
                                      </Button>
                                    </Box>
                                  </Grid>
                                )}
                                {/* <Grid item xs={6}></Grid> */}
                                <Grid
                                  item
                                  xs={12}
                                  style={{
                                    display: "flex",
                                    justifyContent: "end",
                                  }}
                                >
                                  <Button
                                    disableElevation
                                    variant="contained"
                                    color="primary"
                                    style={{
                                      width: "30%",
                                      padding: "4px",
                                      fontSize: "12px",
                                      marginRight: "10px",
                                    }}
                                    onClick={() => {
                                      getData(data.shortlisting_coach_id);
                                      beforeEditSession();
                                      setShortlistCoachID(
                                        data.shortlisting_coach_id
                                      );
                                    }}
                                  >
                                    <EditIcon
                                      style={{
                                        width: "16px",
                                        paddingRight: "16px",
                                      }}
                                    />
                                    <span style={{ textTransform: "none" }}>
                                      Edit
                                    </span>
                                  </Button>
                                </Grid>
                              </Grid>
                            ) : (
                              <Typography
                                variant="h2"
                                style={{
                                  align: "right",
                                  width: "30%",
                                  justifySelf: "end",
                                }}
                              >
                                {data.moved_to_confirmed ? (
                                  <Box
                                    p={2}
                                    borderRadius={6}
                                    textAlign="center"
                                    className={classes.approved}
                                  >
                                    Confirmed
                                  </Box>
                                ) : (
                                  <Box
                                    p={2}
                                    borderRadius={6}
                                    textAlign="center"
                                    className={classes.notApproved}
                                  >
                                    Not Selected
                                  </Box>
                                )}
                              </Typography>
                            )}
                          </Grid>
                        </Grid>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container direction="row" alignItems="center">
                          <Grid item xs="12">
                            <Box>
                              <Grid
                                container
                                direction="row"
                                alignItems="center"
                              >
                                <Grid item xs="6">
                                  <Typography variant="h2">
                                    <Box fontWeight="fontWeightBold">
                                      <DateRangeIcon
                                        style={{
                                          fontSize: 20,
                                          color: "#EF7000",
                                          verticalAlign: "middle",
                                        }}
                                      />{" "}
                                      &nbsp;&nbsp;&nbsp;
                                      <Box
                                        component="span"
                                        style={{ verticalAlign: "middle" }}
                                      >
                                        {DateFormatter(
                                          sessionDetail?.session_date
                                        )}
                                      </Box>
                                    </Box>
                                  </Typography>
                                </Grid>
                                <Grid item xs="6">
                                  <Typography variant="h2">
                                    <Box fontWeight="fontWeightBold" my={3}>
                                      <ScheduleIcon
                                        style={{
                                          fontSize: 20,
                                          color: "#EF7000",
                                          verticalAlign: "middle",
                                        }}
                                      />
                                      &nbsp;&nbsp;&nbsp;
                                      <Box
                                        component="span"
                                        style={{ verticalAlign: "middle" }}
                                      >
                                        {moment(
                                          sessionDetail?.start_time,
                                          "HH:mm:ss"
                                        ).format("LT") +
                                          " - " +
                                          moment(
                                            sessionDetail?.end_time,
                                            "HH:mm:ss"
                                          ).format("LT")}
                                      </Box>
                                    </Box>
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Box>
                            <Box mt={2}>
                              <Grid item xs="12">
                                <Typography variant="h2">
                                  <Box fontWeight="fontWeightBold">
                                    <LocationOnIcon
                                      style={{
                                        fontSize: 20,
                                        color: "#EF7000",
                                        verticalAlign: "middle",
                                      }}
                                    />
                                    &nbsp;&nbsp;&nbsp;
                                    <Box
                                      component="span"
                                      style={{ verticalAlign: "middle" }}
                                    >
                                      {sessionDetail.location}
                                    </Box>
                                  </Box>
                                </Typography>
                              </Grid>
                            </Box>
                            {/* <Box my={4}>
                          <Grid container direction="row" alignItems="center">
                            <Grid item xs="12">
                              <Typography variant="h2">
                                <Box mb={2} fontWeight="fontWeightBold">
                                  Session type
                                </Box>
                              </Typography>
                            </Grid>
                            <Grid item xs="12">
                              <Typography variant="h2">
                                <Box>Hybrid</Box>
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box> */}
                            <Box mt={6} mb={3}>
                              <Grid
                                container
                                direction="row"
                                alignItems="center"
                              >
                                <Grid item xs="10">
                                  <Typography variant="h2">
                                    <Box mb={2} fontWeight="fontWeightBold">
                                      Stakeholders involved
                                    </Box>
                                  </Typography>
                                </Grid>
                                <Grid item xs="12">
                                  <Grid
                                    container
                                    direction="row"
                                    alignItems="center"
                                  >
                                    {sessionDetail?.stakeholders?.map(
                                      (option) => {
                                        return (
                                          <Grid
                                            item
                                            xs="3"
                                            key={option.user_id}
                                          >
                                            <Grid
                                              container
                                              direction="row"
                                              alignItems="center"
                                              justify="space-between"
                                              spacing={1}
                                            >
                                              <Grid item xs="3" md={3}>
                                                <Box>
                                                  <Avatar
                                                    alt="Remy Sharp"
                                                    src={option.image}
                                                    className={classes.small}
                                                  />
                                                </Box>
                                              </Grid>
                                              <Grid item xs="9" md={9}>
                                                <Box>
                                                  <Typography variant="h2">
                                                    <Box fontWeight="fontWeightBold">
                                                      {option.name}
                                                    </Box>
                                                  </Typography>
                                                  <Typography
                                                    variant="h2"
                                                    style={{ color: "#757575" }}
                                                  >
                                                    <Box>{option.role}</Box>
                                                  </Typography>
                                                </Box>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        );
                                      }
                                    )}
                                  </Grid>
                                </Grid>
                                <Grid item xs="12">
                                  <Typography variant="h2">
                                    <Box
                                      mt={4}
                                      mb={2}
                                      fontWeight="fontWeightBold"
                                    >
                                      Session notes
                                    </Box>
                                  </Typography>
                                </Grid>
                                <Grid item xs="12">
                                  <Typography variant="h2">
                                    {sessionDetail?.session_notes}
                                  </Typography>
                                </Grid>
                                <Grid item xs="12">
                                  <Typography variant="h2">
                                    <Box
                                      mt={4}
                                      mb={2}
                                      fontWeight="fontWeightBold"
                                    >
                                      Agenda
                                    </Box>
                                  </Typography>
                                </Grid>
                                <Grid item xs="12">
                                  <Typography variant="h2">
                                    {sessionDetail?.agenda}
                                  </Typography>
                                </Grid>
                                {showAcuityNotes && (
                                  <>
                                    <Grid item xs="12">
                                      <Typography variant="h2">
                                        <Box
                                          mt={4}
                                          mb={1}
                                          fontWeight="fontWeightBold"
                                        >
                                          Acuity admin notes
                                        </Box>
                                      </Typography>
                                    </Grid>
                                    <Grid item xs="12">
                                      <Typography variant="h2">
                                        {sessionDetail.note_to_acuity_admin}
                                      </Typography>
                                    </Grid>
                                  </>
                                )}
                              </Grid>
                            </Box>
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  );
                })}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        action={action}
        open={open}
        fullWidth="100%"
        maxWidth={maxWidth}
        style={{ padding: 24, marginTop: "40px" }}
      >
        <form onSubmit={saveSession}>
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            Scheduling Chemistry Session
          </DialogTitle>
          <DialogContent dividers>
            <Box p={3}>
              <Grid container direction="row">
                <Grid
                  item
                  xs={3}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Typography variant="h2">
                    <Box>Session date</Box>
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <DateComponent
                    key={"1235"}
                    componentObject={{
                      componentType: "datePicker",
                      required: true,
                      label: "",
                      name: "session_date",
                      placeholder: "Start Date",
                      error: sessionInputErrors.session_date,
                      helperText:
                        submitClickFlag && sessionInputErrors.session_date
                          ? "Please select a valid date"
                          : "",
                      indexKey: "0-212",
                      index: "session_date",
                      handleChange: setInputState,
                      value: DateFormat(userData?.session_date),
                      customStyle:
                        submitClickFlag && !userData?.session_date
                          ? { marginBottom: "0px" }
                          : {},
                    }}
                  />
                  {/* <FormHelperText
                    style={{ margin: "2px" }}
                    error={
                      submitClickFlag && !userData?.session_date ? true : false
                    }
                  >
                    {submitClickFlag && !userData?.session_date
                      ? "Session date is required."
                      : null}
                  </FormHelperText> */}
                </Grid>
              </Grid>
              <Grid container direction="row">
                <Grid
                  item
                  xs={3}
                  style={{ alignItems: "center", display: "grid" }}
                >
                  <Typography variant="h2">
                    <Box>Session time</Box>
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Grid container direction="row" spacing={10}>
                    <Grid item xs={6}>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <InputLabel
                            style={{
                              fontSize: "12px",
                              marginBottom: "0.25rem",
                            }}
                            htmlFor="hours-customized-select-native"
                          >
                            Start Time
                          </InputLabel>
                          <FormControl sx={{ m: 1 }} variant="standard">
                            <Select
                              id="hours-customized-select-native"
                              value={clockData.start_time_hours}
                              onChange={(event) => {
                                selectChange(
                                  event.target.value,
                                  "start_time_hours"
                                );
                                if (clockData.start_time_minutes === "") {
                                  selectChange("00", "start_time_minutes");
                                }
                              }}
                              variant="outlined"
                              className={classes.nativeSelect}
                              style={{
                                color:
                                  clockData.start_time_hours === ""
                                    ? "#999"
                                    : "#222",
                              }}
                              displayEmpty
                              error={sessionInputErrors.start_time_hours}
                            >
                              <MenuItem
                                style={{ fontSize: "14px" }}
                                disabled
                                value=""
                              >
                                Start hour
                              </MenuItem>
                              {hourArray &&
                                hourArray.map((e) => {
                                  return (
                                    <MenuItem
                                      style={{ fontSize: "14px" }}
                                      value={e}
                                    >
                                      {e}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          style={{ display: "flex", alignItems: "flex-end" }}
                        >
                          <FormControl sx={{ m: 1 }} variant="standard">
                            <Select
                              id="minutes-customized-select-native"
                              value={
                                clockData.start_time_hours !== "24"
                                  ? clockData.start_time_minutes
                                  : "00"
                              }
                              onChange={(event) =>
                                selectChange(
                                  event.target.value,
                                  "start_time_minutes"
                                )
                              }
                              style={{
                                color:
                                  clockData.start_time_minutes === ""
                                    ? "#999"
                                    : "#222",
                              }}
                              variant="outlined"
                              displayEmpty
                              className={classes.nativeSelect}
                              error={sessionInputErrors.start_time_minutes}
                            >
                              <MenuItem
                                style={{ fontSize: "14px" }}
                                disabled
                                value=""
                              >
                                Start minutes
                              </MenuItem>
                              {minuteArray &&
                                minuteArray.map((e) => {
                                  return (
                                    <MenuItem
                                      value={e}
                                      disabled={
                                        clockData.start_time_hours === "24" &&
                                        e !== "00"
                                      }
                                    >
                                      {e}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={6}>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <InputLabel
                            style={{
                              fontSize: "12px",
                              marginBottom: "0.25rem",
                            }}
                            htmlFor="hours-customized-select-native"
                          >
                            End Time
                          </InputLabel>
                          <FormControl sx={{ m: 1 }} variant="standard">
                            <Select
                              id="hours-customized-select-native"
                              value={clockData.end_time_hours}
                              onChange={(event) => {
                                selectChange(
                                  event.target.value,
                                  "end_time_hours"
                                );
                                if (clockData.end_time_minutes === "") {
                                  selectChange("00", "end_time_minutes");
                                }
                              }}
                              className={classes.nativeSelect}
                              style={{
                                color:
                                  clockData.end_time_hours === ""
                                    ? "#999"
                                    : "#222",
                              }}
                              variant="outlined"
                              displayEmpty
                              error={sessionInputErrors.end_time_hours}
                            >
                              <MenuItem
                                style={{ fontSize: "14px" }}
                                disabled
                                value=""
                              >
                                End hours
                              </MenuItem>
                              {hourArray &&
                                hourArray.map((e) => {
                                  return (
                                    <MenuItem
                                      value={e}
                                      style={{ fontSize: "14px" }}
                                    >
                                      {e}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          style={{ display: "flex", alignItems: "flex-end" }}
                        >
                          <FormControl sx={{ m: 1 }} variant="standard">
                            <Select
                              id="minutes-customized-select-native"
                              value={
                                clockData.end_time_hours !== "24"
                                  ? clockData.end_time_minutes
                                  : "00"
                              }
                              onChange={(event) =>
                                selectChange(
                                  event.target.value,
                                  "end_time_minutes"
                                )
                              }
                              className={classes.nativeSelect}
                              style={{
                                color:
                                  clockData.end_time_minutes === ""
                                    ? "#999"
                                    : "#222",
                              }}
                              variant="outlined"
                              displayEmpty
                              error={sessionInputErrors.end_time_minutes}
                            >
                              <MenuItem
                                style={{ fontSize: "14px" }}
                                disabled
                                value=""
                              >
                                End minutes
                              </MenuItem>
                              {minuteArray &&
                                minuteArray.map((e) => {
                                  return (
                                    <MenuItem
                                      value={e}
                                      disabled={
                                        clockData.end_time_hours === "24" &&
                                        e !== "00"
                                      }
                                      style={{ fontSize: "14px" }}
                                    >
                                      {e}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <FormHelperText
                    style={{ margin: "2px 2px 2px 6px", color: "red" }}
                  >
                    {sessionInputErrors.start_time_hours ||
                    sessionInputErrors.start_time_minutes ||
                    sessionInputErrors.end_time_hours ||
                    sessionInputErrors.end_time_minutes
                      ? "Please enter a valid time"
                      : ""}
                  </FormHelperText>
                </Grid>
              </Grid>

              <Grid container direction="row" style={{ marginTop: 20 }}>
                <Grid item xs={3}>
                  <Typography variant="h2">
                    <Box>Location</Box>
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <CustomInput
                    id="location"
                    // disabled={sessionDetail?.status === "completed" ? true : false}
                    placeholder="Location"
                    variant="outlined"
                    parentcall={setInputState}
                    value={userData.location}
                    helperText={
                      submitClickFlag && sessionInputErrors.location
                        ? "Please enter a location"
                        : ""
                    }
                    error={submitClickFlag && sessionInputErrors.location}
                  />
                </Grid>
              </Grid>
              <Grid container direction="row" style={{ marginTop: 20 }}>
                <Grid item xs={3}>
                  <Typography variant="h2">
                    <Box>Stakeholders involved</Box>
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <CustomSelectMulti
                    id="stakeholder_Attribute"
                    itemArr={stakeholderListsArr}
                    parentcall={onChangeMultiItem}
                    placeholder="Search by name"
                    value={stakeholder_Attribute}
                    error={
                      submitClickFlag && sessionInputErrors.stakeHoldersInvolved
                    }
                    helperText={
                      submitClickFlag && sessionInputErrors.stakeHoldersInvolved
                        ? "Please select the stakeholders involved"
                        : ""
                    }
                  />
                </Grid>
              </Grid>
              <Grid container direction="row" style={{ marginTop: 20 }}>
                <Grid item xs={3}>
                  <Typography variant="h2">
                    <Box>Agenda</Box>
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <FormControl style={{ width: "100%" }} variant="outlined">
                    <TextareaAutosize
                      aria-label="minimum height"
                      name="agenda"
                      rowsMin={8}
                      className={classes.textAreaEmpty}
                      onChange={handleChangeTextArea}
                      value={textArea.agenda}
                      placeholder="Agenda"
                    />
                    {/* {submitClickFlag && !textArea.agenda ? (
                      <FormHelperText style={{ color: "red" }}>
                        Please add Agenda
                      </FormHelperText>
                    ) : (
                      <></>
                    )} */}
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container direction="row" style={{ marginTop: 20 }}>
                <Grid item xs={3}>
                  <Typography variant="h2">
                    <Box>Add session notes</Box>
                  </Typography>
                </Grid>

                <Grid item xs={9}>
                  <FormControl style={{ width: "100%" }} variant="outlined">
                    <TextareaAutosize
                      aria-label="minimum height"
                      name="session_notes"
                      rowsMin={8}
                      className={classes.textAreaEmpty}
                      onChange={handleChangeTextArea}
                      value={textArea.session_notes}
                      placeholder="Add session notes"
                    />
                    {/* {submitClickFlag && !textArea.session_notes ? (
                      <FormHelperText style={{ color: "red" }}>
                        Please enter the session notes
                      </FormHelperText>
                    ) : (
                      <></>
                    )} */}
                  </FormControl>
                </Grid>
              </Grid>
              {showAcuityNotes && (
                <Grid container direction="row" style={{ marginTop: 20 }}>
                  <Grid item xs={3}>
                    <Typography variant="h2">
                      <Box>Add note to Acuity Admin</Box>
                    </Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <FormControl style={{ width: "100%" }} variant="outlined">
                      <TextareaAutosize
                        aria-label="minimum height"
                        name="note_to_acuity_admin"
                        rowsMin={8}
                        className={classes.textAreaEmpty}
                        onChange={handleChangeTextArea}
                        value={textArea.note_to_acuity_admin}
                        placeholder="Add note to Acuity Admin"
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Box px={3} py={2}>
              <Button
                disableElevation
                variant="contained"
                onClick={handleClose}
                style={{ textTransform: "none" }}
              >
                Cancel
              </Button>
              <Button
                disableElevation
                variant="contained"
                color="secondary"
                onClick={handleClickOpen}
                style={{ marginLeft: 10, textTransform: "none" }}
              >
                Save and Email
              </Button>
              <Button
                disableElevation
                type="submit"
                variant="contained"
                color="secondary"
                style={{ marginLeft: 10, textTransform: "none" }}
              >
                {action === "edit" ? "Update" : "Save"}
              </Button>
            </Box>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default ChemistrySession;
